import { StyledRiskIndicator } from './RiskIndicator.styles';

export const RiskIndicator = ({
  score,
  width = '10px',
  height = '10px',
  ...props
}) => (
  <StyledRiskIndicator {...props} width={width} score={score} height={height} />
);
